<style>
    .tanker-container {
        display: flex;
        position: absolute;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        top: 18px;
    }

    .tanker-volume-percentage {
        position: relative;
        border-radius: 38px;
        width: 71%;
        height: 79px;
        border-radius: 38px;
        margin-left: -1px;
        margin-top: 1px;
        overflow: hidden;
    }

    .tanker-volume-percentage span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        z-index: 2;
        text-shadow: 0px 1px 1px #E6E6E6;

    }

    .tanker-height {
        display: flex;
        justify-content: center;
        font-weight: bold;
        position: absolute;
        background-color: #4973ff;
        bottom: 8px;
        z-index: 1;
        transition: height 1.5s ease-in-out;


    }

    .image-wrapper {
        z-index: 1;
        position: relative;
        width: 100%;
        max-width: 120px;
        max-width: 120px;
        height: 120px;
        aspect-ratio: 1;
        overflow: hidden;
    }

    .base-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 4;
    }

    .color-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .top-mask {
        position: absolute;
        top: 10px;
        left: 22px;
        width: 63%;
        background: white;
        z-index: 3;
        pointer-events: none;
        transition: height 1.5s ease-in-out;

    }
</style>

<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <div class="d-flex align-items-center">
            <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        </div>

        <i class="fa fa-question-circle text-light my-auto fa-2x" (click)="guid()"></i>



    </div>

</div>

<div class="d-flex flex-column flex-md-row justify-content-center align-items-center w-100">

    <button *ngIf="fTotalDistance || strTotalTime" [ngClass]="animatemod ? 'btn-secondary' : 'btn-info' " class="btn index-3 mt-3 dirI " style="width: fit-content;z-index: 1;">

        <ng-container *ngIf="!animatemod">

            <span class="mx-3" *ngIf="fTotalDistance"> پیمایش کل ( km ) :

                <span class="fw-bold"> {{ fTotalDistance | faNum }} </span>

            </span>

            <span> زمان کل :

                <span class="fw-bold"> {{ strTotalTime | faNum }} </span>

            </span> <br>

            <ng-container>

                <span> نام خودرو :
    
                    <span class="fw-bold text-dark px-3"> {{ carName | faNum }} </span>
    
                </span>
    
                <span> پلاک :
    
                    <span class="fw-bold"> {{ formatted_pelak(carPelak) | faNum }} </span>
    
                </span>

            </ng-container>

        </ng-container>

        <ng-container *ngIf="animatemod">

            <ng-container>

                <span> 
    
                    <span class="text-warning px-3">
    
                        <span class="fw-bold">{{ carName | faNum }} </span>
    
                    </span>
    
                </span>
                    
                <br>
    
                <span> 
                    
                    {{ formatted_pelak(carPelak) | faNum }} 
                
                </span>

                <ng-container *ngIf="startTime != undefined && !FuelTanker">

                    <br>
    
                    <span class="mx-3"> 
                        
                        زمان :
        
                        <span class="text-warning"> {{ startTime | faNum }} </span>
        
                    </span>

                </ng-container>

                <ng-container *ngIf="carSpeed != undefined && !FuelTanker">

                    <span> سرعت ( km/h ) :
        
                        <span class="text-warning"> {{ carSpeed | faNum }} </span>
        
                    </span>
    
                    <br>

                </ng-container>

            </ng-container>

            <ng-container *ngIf="FuelTanker">

                <br>

                <span class=""> 
    
                    <span class="text-warning">
    
                        <span class="fw-bold"> {{ mdl_Line.get('strSDate')?.value | faNum }} </span>

                        <span class="text-white"> الی </span>

                        <span class="fw-bold"> {{ mdl_Line.get('strEDate')?.value | faNum }} </span>
    
                    </span>
    
                </span>

                <br>

                <ng-container *ngIf="fullDateTime">

                    <span> زمان فعلی :
        
                        <span class="text-warning">
        
                            <span class="fw-bold">{{ fullDateTime | faNum }} </span>
        
                        </span>
        
                    </span>
    
                    <br>

                </ng-container>

            </ng-container>

        </ng-container>

        <ng-container *ngIf="animatemod && (bTankerRoute || FuelTanker)">

            <ng-container *ngIf="tankerFill != 0">

                <span class="mx-3"> {{ FuelTanker ? 'درصد فعلی باک' : 'درصد پرشدگی حجم تانکر' }} :

                    <span class="text-warning"> %{{ tankerFill.toLocaleString() | faNum }} </span>

                </span>

            </ng-container>

            <br>

            <span class="mx-3" *ngIf="tankerVolume != 0"> {{ FuelTanker ? 'حجم فعلی (لیتر)' : 'حجم آب موجود در تانکر(لیتر)' }} :

                <span class="text-warning"> {{ tankerVolume.toLocaleString() | faNum }} </span>

            </span>

        </ng-container>

    </button>

    <!-- شبیه سازی حجم تانکر -->

    <div *ngIf="animatemod && bTankerRoute"
        class="d-flex justify-content-center align-items-center mx-0 mx-md-3 mt-2 index-3">

        <div class="d-flex justify-content-center align-items-center position-relative"
            style="overflow: hidden; max-width:250px;height:155px;">

            <img width="250px" style="z-index:10;" src="../../../assets/Img/tankwagen.png" alt="">

            <div class="tanker-container">

                <div class="tanker-volume-percentage bg-white">

                    <span class="postion-absolute"> {{ ( tankerFill | faNum ) + '%' }} </span>

                    <div class="tanker-height w-100" [style.height.%]="tankerHeight"></div>

                </div>

            </div>

        </div>

    </div>

    <!-- شبیه سازی حجم باک -->

    <div *ngIf="animatemod && FuelTanker"
        class="d-flex flex-column justify-content-center align-items-center mx-0 mx-md-3 mt-2 index-3">

        <div class="d-flex justify-content-center align-items-center position-relative"
            style="overflow: hidden; max-width:250px;height:155px;">

            <div class="image-wrapper">

                <img src="../../../assets/Img/oil-1.png" class="base-image" alt="سیاه سفید">

                <img src="../../../assets/Img/oil-2.png" class="color-image" alt="رنگی">

                <div class="top-mask" [style.height.%]="100 - tankerHeight"></div>

            </div>

        </div>

    </div>

</div>


<div class="icon-Map position-absolute index d-flex flex-column ">

    <button class="p-2 circel-2 my-1 text-center pointer  icon-Img bg-third d-flex" [disabled]="exportPdf"
        (click)="exportPdfMap()">
        <i class="fa fa-file-pdf-o bold" title="خروجی pdf"></i>
    </button>
    <img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()"
        class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img">

</div>

<div class="d-flex flex-wrap justify-content-center position-absolute" style="bottom: 10px; margin-left: auto; margin-right: auto; left: 0; right: 0; text-align: center;" *ngIf="!animatemod">

    <div class="button-container bg-white row gx-2 gy-0 index py-3 px-2 rounded" style="max-width: 305px;">

        <!-- تاریخ -->

        <div [formGroup]="mdl_Date" class="col-12 p-2">

            <div class="rounded text-white index f14 routel bg-light py-1">
        
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" 

                    (dateOnSelect)="onSelectDate($event)" [dateInitValue]="false"
                
                    [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
        
                    <input type="text" formControlName="strSDate" 
                    
                        class="w-100 form-control text-center" 
                        
                        placeholder="تاریخ را انتخاب کنید" />
        
                </ng-persian-datepicker>
        
            </div>

        </div>

        <!-- شبیه سازی -->

        <div *ngIf="routeLenght > 1" class="col-6">

            <div class="rounded text-white index f14 router bg-light py-1">
        
                <button class="btn bg-primary text-white w-100" (click)="animate(0,routeLenght+1)">
        
                    <small> شبیه سازی </small>
        
                </button>
        
            </div>

        </div>

        <!-- نمایش اطلاعات -->

        <div *ngIf="!animatemod" class="col-6">

            <div class="rounded text-white index f14 router-info bg-light py-1">
        
                <button class="btn btn-success w-100" data-bs-toggle="modal" data-bs-target="#info">
        
                    <small> نمایش اطلاعات </small>
        
                </button>
        
            </div>

        </div>

        <!-- محاسبه نرم افزاری -->

        <div *ngIf="!animatemod && access.bReCalDistance" class="col-6">

            <div class="rounded text-white index f14 router-calc bg-light py-1">
        
                <button class="btn btn-info text-white w-100" (click)="recallDistance()"> 
                    
                    <small> محاسبه نرم افزاری </small>
        
                </button>
        
            </div>

        </div>

        <!-- نمایش جهت نما -->

        <div *ngIf="routeLenght > 1" class="col-6">
        
            <div class="rounded text-white index f14 routel bg-light py-1">
        
                <button class="btn bg-secondary text-white w-100" *ngIf="showArrowbtn" (click)="showArrow()">
        
                    <small> نمایش جهت نما </small>
        
                </button>
        
                <button class="btn bg-secondary text-white w-100" *ngIf="!showArrowbtn" (click)="RemoveArrow()">
        
                    <small> حذف جهت نما </small>
        
                </button>
        
            </div>

        </div>

    </div>


</div>

<!-- شبیه سازی حرکت -->

<div class="d-flex justify-content-center w-100 mt-3 bg-white" *ngIf="animatemod">

    <div class="px-3 rounded text-white index position-absolute f14 animatemod bg-light py-3">

        <div class="d-flex justify-content-between">

            <label class="text-dark"> سریع تر </label> <label class="text-dark text-strat"> کند تر </label>

        </div>

        <input type="range" class="form-range" min="0.4" max="4" step="0.2" id="customRange3"
            (change)="speedChange($event)" value="0.5">

        <div class="d-flex justify-content-center mb-2">

            <ng-container>
                
                <span class="text-dark" *ngIf="dataTa"> دوره زمانی : 
                    
                    <strong> {{ dataAz | faNum }} </strong>
                    
                    الی 
                    
                    <strong> {{ dataTa | faNum }}  </strong>
                    
                </span>

            </ng-container>

        </div>

        <ngx-slider [(value)]="value" [(highValue)]="highValue" [options]="options" (valueChange)="ch($event)" (highValueChange)="ch2($event)"></ngx-slider>

            <div [formGroup]="mdl_Line" class="row gx-0 gy-0 mt-2">

                <div class="col-auto">

                    <ng-container *ngIf="stop">

                        <button class="btn text-white" [ngClass]="isAnimationPause ? 'btn-warning' : 'btn-danger' " (click)="isAnimationPause ? ResumeAnimate() : PauseAnimate()" [title]="isAnimationPause ? 'ادامه' : 'توقف'">

                            <i class="fa" [ngClass]="isAnimationPause ? 'fa-play-circle text-dark' : 'fa-stop text-white'"></i>

                        </button>

                        <button class="btn btn-success text-white mx-2" (click)="stopAnimate()" title="شروع مجدد">

                            <i class="fa fa-refresh text-white"></i>

                        </button>
                        
                    </ng-container>
                        
                    <button class="btn bg-third text-white" *ngIf="!stop" (click)="replay()" title="شروع مجدد"> 

                        <i class="fa fa-play-circle text-warning"></i>
                
                    </button>

                </div>

                <div class="form-check form-switch m-0 d-flex align-items-center justify-content-end col-auto p-2">

                    <input class="form-check-input m-0" type="checkbox" id="drawLine" formControlName="drawLine">

                    <label class="form-check-label pointer text-muted me-2" for="drawLine"> ترسیم دنباله </label>

                </div>
                
            </div>

       

    </div>

    <!-- <div class="px-3 rounded text-white index position-absolute f14 animatemod bg-light py-3">

    </div> -->

</div>

<div id="test" class="fixed-map3">
    <div class="position-absolute" id="map_tooltip" data-bs-html="true">
    </div>
</div>

<!--Modal-->
<div class="modal fade" id="info" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" dir="rtl">
            <div class="modal-header">
                <h5 class="modal-title" id="">اطلاعات</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <i class="fa fa-rotate-right text-secondary my-auto ms-2 pointer" (click)="reload()"></i>
            </div>
            <div class="modal-body">
                <div *ngIf="routeData">تعداد نقاط : {{routeData.length}}</div>
                <div class="table-responsive dirI rounded-3" style="max-height: 60vh; ">
                    <table class="table mt-1 table-striped overflow-auto" id="excel-info">
                        <thead class="">
                            <tr class="text-center">

                                <th scope="col" class="">ردیف </th>
                                <th scope="col" class=""> عملیات </th>
                                <th scope="col" class="">تاریخ </th>
                                <th scope="col" class="pointer" (click)="sortTime()"><i class="fa fa-sort-amount-asc"
                                        aria-hidden="true"></i>&nbsp;ساعت</th>
                                <th scope="col" class="">سرعت </th>
                                <th scope="col" class="">زاویه </th>
                                <th scope="col" class="">فاصله</th>
                                <th scope="col" class=""> وضعیت</th>
                                <th scope="col" class=""> طول جغرافیایی</th>
                                <th scope="col" class="">عرض جغرافیایی </th>
                                <th scope="col" class=""> اطلاعات </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let item of routeData?.slice().reverse();let i=index">
                                <th class="text-dark">{{i+1}}</th>
                                <th class="text-dark">
                                    <i class="fa fa-map-marker fa-lg pointer" (click)="open_Map(item)"></i>
                                </th>
                                <th class="text-dark">{{item.strDate}}</th>
                                <th class="text-dark pointer">{{item.strTime}}</th>
                                <th class="text-dark">{{item.iSpeed}}</th>
                                <th class="text-dark">{{item.iAngle}}</th>
                                <th class="text-dark">{{item.fDistance}}</th>
                                <th class="text-dark">{{item.bOnOff ? 'روشن' : 'خاموش' }}</th>
                                <th class="text-dark">{{item.fLon}}</th>
                                <th class="text-dark">{{item.fLat}}</th>
                                <th class="text-dark">{{item.strPosName}}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-success" (click)="exportexcel('excel-info')">خروجی اکسل</button>
                <button type="button" class="btn btn-info" *ngIf="access.bReCalDistance"
                    (click)="recallDistance()">محاسبه نرم افزاری فاصله ها</button>
            </div>
        </div>
    </div>
</div>

<!-- مدال نقشه -->

<custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value" [isView]="true"
    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
    (mdl_Submit)="showCustom_Map=false">

</custom-map>